/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {CampaignSegments} from './CampaignSegments';
import {CampaignSettings} from './CampaignSettings';
import {CampaignTemplates} from './CampaignTemplates';
import {ESP} from './ESP';
import {Property} from './Property';

/**
 * The Campaign model module.
 * @module model/Campaign
 * @version 1.0.0
 */
export class Campaign {
  /**
   * Constructs a new <code>Campaign</code>.
   * @alias module:model/Campaign
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Campaign</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Campaign} obj Optional instance to populate.
   * @return {module:model/Campaign} The populated <code>Campaign</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Campaign();
      if (data.hasOwnProperty('_id'))
        obj._id = ApiClient.convertToType(data['_id'], 'String');
      if (data.hasOwnProperty('property'))
        obj.property = Property.constructFromObject(data['property']);
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('templates'))
        obj.templates = CampaignTemplates.constructFromObject(data['templates']);
      if (data.hasOwnProperty('segments'))
        obj.segments = CampaignSegments.constructFromObject(data['segments']);
      if (data.hasOwnProperty('esp'))
        obj.esp = ESP.constructFromObject(data['esp']);
      if (data.hasOwnProperty('settings'))
        obj.settings = CampaignSettings.constructFromObject(data['settings']);
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('updated'))
        obj.updated = ApiClient.convertToType(data['updated'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} _id
 */
Campaign.prototype._id = undefined;

/**
 * @member {module:model/Property} property
 */
Campaign.prototype.property = undefined;

/**
 * @member {String} title
 */
Campaign.prototype.title = undefined;

/**
 * @member {String} description
 */
Campaign.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
Campaign.prototype.enabled = undefined;

/**
 * @member {module:model/CampaignTemplates} templates
 */
Campaign.prototype.templates = undefined;

/**
 * @member {module:model/CampaignSegments} segments
 */
Campaign.prototype.segments = undefined;

/**
 * @member {module:model/ESP} esp
 */
Campaign.prototype.esp = undefined;

/**
 * @member {module:model/CampaignSettings} settings
 */
Campaign.prototype.settings = undefined;

/**
 * @member {String} created
 */
Campaign.prototype.created = undefined;

/**
 * @member {String} updated
 */
Campaign.prototype.updated = undefined;

